/* unplugin-vue-components disabled */import script from "./ResList.vue?vue&type=script&setup=true&lang=js"
export * from "./ResList.vue?vue&type=script&setup=true&lang=js"

import "./ResList.vue?vue&type=style&index=0&id=909b7c30&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-909b7c30"]])

export default __exports__